import { Travel as ProTravel, TravelApiInterface as ProTravelApiInterface } from "@syadem/kairos-pro-js";
import { Travel as TeamTravel, TravelApiInterface as TeamTravelApiInterface } from "@syadem/kairos-team-js";
import { ActionResult } from "../../actionResult";
import { TravelSnapshot } from "../../domain/travel";
import { toApiTravel } from "../../network/apis/travelMapper";
import { AppStore } from "../../store";
import { Service } from "../service";

interface Payload {
  organizationId: string | null;
  teamId: string | null;
  healthRecordId: string;
  travel: TravelSnapshot;
}

export class CreateTravelService implements Service<Payload, ProTravel | TeamTravel> {
  constructor(
    private readonly proTravelApi: ProTravelApiInterface,
    private readonly teamTravelApi: TeamTravelApiInterface,
    private readonly store: AppStore,
  ) {}

  async call({ organizationId, teamId, healthRecordId, travel }: Payload): Promise<ActionResult<ProTravel | TeamTravel>> {
    const body = { travel: toApiTravel(travel) };
    const createdTravel =
      organizationId && teamId
        ? await this.teamTravelApi.createTravel(organizationId, teamId, healthRecordId, body)
        : await this.proTravelApi.createTravel(healthRecordId, body);

    this.store.setState((state) =>
      state.healthRecords?.[healthRecordId]
        ? {
            healthRecords: {
              ...state.healthRecords,
              [healthRecordId]: {
                ...state.healthRecords[healthRecordId],
                travels: [...(state.healthRecords[healthRecordId].travels ?? []), createdTravel],
              },
            },
          }
        : state,
    );

    return { type: "success", value: createdTravel };
  }
}
